import { baseURL } from '../Config'
import axios from 'axios';
import { toast } from "react-toastify";


export async function fetchApi(url,body) {
    try {
      const response = await axios.get(`${baseURL}${url}`,body);
      // Check if response exists and has data
      if (!response || !response.data) {
        toast.error('No response received from server');
        throw new Error('No response received');
      }
  
      // If there's an error message in the response, show it and throw
      if (response.data.errorMessage) {
        toast.error(response.data.errorMessage);
        throw new Error(response.data.errorMessage);
      }
  
      // If status is not 200 or message is not success, show error
      if (response.status !== 200 || response.data.message !== "success") {
        const errorMsg = response.data.errorMessage || 'Operation failed';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }
  
      return response.data;
  
    } catch (error) {
      // Handle axios errors
      if (error.response) {
        // Server responded with error status
        const errorMsg = error.response.data.errorMessage || error.response.data.message || 'Server error';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      } else if (error.request) {
        // Request made but no response
        toast.error('No response from server');
        throw new Error('No response from server');
      } else {
        // Other errors
        toast.error(error.message || 'Request failed');
        throw error;
      }
    }
}
  


export async function fetchPostApi(url,body) {
    try {
      const response = await axios.post(`${baseURL}${url}`,body);
      // Check if response exists and has data
      if (!response || !response.data) {
        toast.error('No response received from server');
        throw new Error('No response received');
      }
  
      // If there's an error message in the response, show it and throw
      if (response.data.errorMessage) {
        toast.error(response.data.errorMessage);
        throw new Error(response.data.errorMessage);
      }
  
      // If status is not 200 or message is not success, show error
      if (response.status !== 200 || response.data.message !== "success") {
        const errorMsg = response.data.errorMessage || 'Operation failed';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }
  
      return response.data;
  
    } catch (error) {
      // Handle axios errors
      if (error.response) {
        // Server responded with error status
        const errorMsg = error.response.data.errorMessage || error.response.data.message || 'Server error';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      } else if (error.request) {
        // Request made but no response
        toast.error('No response from server');
        throw new Error('No response from server');
      } else {
        // Other errors
        toast.error(error.message || 'Request failed');
        throw error;
      }
    }
}

export async function listAllCategories(token ) {
    try {
        const body = {
            token
        }
        const response = await fetchApi('manufacturer/ecom/all-categories', {
            headers: {
                Authorization: token,
            }
        })
        return response
    } catch (error) {
        toast.error(error.message);
        throw error;
    }
}
export async function listAllProducts(token, params) {   
    try {
        const { search, categoryId, isNew, page = 1, limit = 1000 } = params;
        
        // Build query string
        const queryParams = new URLSearchParams({
            ...(search && { search }),
            ...(categoryId && { categoryId }),
            ...(isNew !== undefined && { isNew }),
            page: page.toString(),
            limit: limit.toString()
        }).toString();

        const response = await fetchApi(`ecom/marketplace?${queryParams}`, {
            headers: {
                Authorization: token,
            }
        });
        
        return response;
    } catch (error) {
        toast.error(error.message);
        throw error;
    }
}   

export async function productDetail(token, productId) {
    try {
        const response = await fetchApi(`manufacturer/ecom/products/${productId}/details`, {
            headers: {
                Authorization: token,
            }
        });
        return response;
    } catch (error) {
        toast.error(error.message);
        throw error;
    }
}

// export async function requestContact(token, productId) {
//     try {
//         const response = await fetchPostApi(`manufacturer/ecom/products/${productId}/contact`, {
//             headers: {
//                 Authorization: token,
//             }
//         });
//         return response;
//     } catch (error) {
//         toast.error(error.message);
//         throw error;
//     }
// }



  
export async function requestContact(token, productId) {
    try {
    
  
        const response = await axios.post(`${baseURL}manufacturer/ecom/products/${productId}/contact`, {},
       { 
        headers: {
            Authorization: token,
          },
      }
      );
  
      // Check if response exists and has data
      if (!response || !response.data) {
        toast.error('No response received from server');
        throw new Error('No response received');
      }
  
      // If there's an error message in the response, show it and throw
      if (response.data.errorMessage) {
        toast.error(response.data.errorMessage);
        throw new Error(response.data.errorMessage);
      }
  
      // If status is not 200 or message is not success, show error
      if (response.status !== 200 || response.data.message !== "success") {
        const errorMsg = response.data.errorMessage || 'Operation failed';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }
  
      return response.data;
  
    } catch (error) {
      // Handle axios errors
      if (error.response) {
        // Server responded with error status
        const errorMsg = error.response.data.errorMessage || error.response.data.message || 'Server error';
        toast.error(errorMsg);
        throw new Error(errorMsg);
      } else if (error.request) {
        // Request made but no response
        toast.error('No response from server');
        throw new Error('No response from server');
      } else {
        // Other errors
        toast.error(error.message || 'Request failed');
        throw error;
      }
    }
}
  
export async function storeDetails(token, vendorId ,params) {
  try {
    const { search='',isNew } = params;
       
    const queryParams = new URLSearchParams({
      ...(search && { search }),      // Include search if provided
      ...(isNew !== undefined && { isNew }),  // Include isNew if provided
  }).toString();
        const response = await fetchApi(`manufacturer/ecom/store-details/${vendorId}?${queryParams}`, {
            headers: {
                Authorization: token,
            }
        });
        return response;
    } catch (error) {
        toast.error(error.message);
        throw error;
    }
}


export async function   listAllInventory(token,params) {
  try {
    const { search='', categoryId ,isNew, page = 1, limit = 1000 } = params;
       
    const queryParams = new URLSearchParams({
      ...(search && { search }),      // Include search if provided
      ...(categoryId && { categoryId }),  // Include categoryId if provided
      ...(isNew !== undefined && { isNew }),  // Include isNew if provided
      page: page.toString(),
      limit: limit.toString()
  }).toString();
    
        const response = await fetchApi(`ecom/products?${queryParams}`, {
            headers: {
                Authorization: token,
            }
        });
        return response;
    } catch (error) {
        toast.error(error.message);
        throw error;
    }
}



export async function AddEcomInventoryApi(token, formData) {
  try {
   
    const response = await axios.post(`${baseURL}manufacturer/ecom/products`, formData, {
      headers: {
        Authorization: token,
      },
    });

    // Check if response exists and has data
    if (!response || !response.data) {
      toast.error('No response received from server');
      throw new Error('No response received');
    }

    // If there's an error message in the response, show it and throw
    if (response.data.errorMessage) {
      toast.error(response.data.errorMessage);
      throw new Error(response.data.errorMessage);
    }

   
    return response.data;

  } catch (error) {
 
  }
}


export async function editInventory(token, productId, formData) {
  try {
    const response = await axios.put(
      `${baseURL}manufacturer/ecom/products/${productId}`,
      formData,
      {
        headers: {
          'Authorization': token,
        }
      }
    );

    if (!response || !response.data) {
      throw new Error('No response received from server');
    }

    if (response.data.errorMessage) {
      throw new Error(response.data.errorMessage);
    }

    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.errorMessage || error.message || 'Failed to update inventory';
    toast.error(errorMsg);
    throw new Error(errorMsg);
  }
}


export async function getCategoryList(token) {
  try {
     
// Construct URL based on whether search exists
const url = `${baseURL}manufacturer/categories`

 const response = await axios.get(url,{
  headers: {
    Authorization: token,
  } 
 })
      if (response && response.status === 200 && response.data.message === 'success') {
          return response.data;
      }else {
          toast.error(`Unexpected response: ${response.data.errorMessage}`);
       
        }
  }  catch (error) {
    // Handle axios errors
    if (error.response) {
        // Server responded with error status
        const errorMsg = error.response.data.errorMessage || error.response.data.message || 'Server error';
        toast.error(errorMsg);
        throw new Error(errorMsg);
    } else if (error.request) {
        // Request made but no response
        toast.error('No response from server');
        throw new Error('No response from server');
    } else {
        // Other errors
        toast.error(error.message || 'Request failed');
        throw error;
    }
}
}

export async function addRating(token, productId , rating, review) {
  try {
    const response = await axios.post(
      `${baseURL}manufacturer/ecom/products/${productId}/rating`, {
        rating,review
      } ,    
      {
        headers: {
          'Authorization': token,
        }
      }
    );

    if (!response || !response.data) {
      throw new Error('No response received from server');
    }

    if (response.data.errorMessage) {
      throw new Error(response.data.errorMessage);
    }

    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.errorMessage || error.message || 'Failed to update inventory';
    toast.error(errorMsg);
    throw new Error(errorMsg);
  }
}

export async function listAllMyProducts(token, params) {   
  try {
      const { search, categoryId, isNew, page = 1, limit = 1000 } = params;
      
      // Build query string
      const queryParams = new URLSearchParams({
          ...(search && { search }),
          ...(categoryId && { categoryId }),
          ...(isNew !== undefined && { isNew }),
          page: page.toString(),
          limit: limit.toString()
      }).toString();

      const response = await fetchApi(`manufacturer/ecom/products?${queryParams}`, {
          headers: {
              Authorization: token,
          }
      });
      
      return response;
  } catch (error) {
      toast.error(error.message);
      throw error;
  }
} 


export async function fetchInterestVendor(token) {
  try { 
    const response = await fetchApi(`manufacturer/ecom/contact-requests`, {
      headers: {
        Authorization: token,
    }
  });
  return response;
} catch (error) {
  toast.error(error.message);
  throw error;
}
}


export async function addNewCategory(token, Data) {
  try {
    // Validate inputs
    if (!token) {
      throw new Error('Token is required');
    }
    
    if (!Data || typeof Data !== 'object') {
      throw new Error('Invalid data provided');
    }

    const formData = new FormData();
    
    // Check if name exists and is a string before adding
    if (Data.name && typeof Data.name === 'string') {
      formData.append('name', Data.name.trim());
    } else {
      throw new Error('Category name is required');
    }
    
    // Check if img exists and is a File before adding
    if (Data.img && Data.img instanceof File) {
      formData.append('img', Data.img);
    } else {
      throw new Error('Category image is required');
    }

  
    const response = await axios.post(`${baseURL}manufacturer/new-add-category`, formData, {
      headers: {
        Authorization: token,
      }
    });
    
    if (response && response.status === 200 && response.data.message === "success") {
      return response.data;
    } else {
      toast.error(`Unexpected response: ${response.data.errorMessage}`);
      console.error("Unexpected response:", response, response.data.errorMessage);
    }
  } catch (error) {
    // Handle axios errors
    if (error.response) {
      const errorMsg = error.response.data.errorMessage || error.response.data.message || 'Server error';
      toast.error(errorMsg);
      throw new Error(errorMsg);
    } else {
      toast.error(error.message || 'Request failed');
      throw error;
    }
  }
}